import styled from 'styled-components';

export const ConfirmationModalWrapper = styled.div<{ isClose: boolean }>`
  ${({ theme, isClose }) =>
    isClose &&
    `
    .ant-btn-primary {
      background-color: ${theme.colors.tone.yellow};
      border-color: ${theme.colors.tone.yellow};
    }
    .ant-btn-primary:hover {
      background-color: ${theme.colors.tone.yellow};
      border-color: ${theme.colors.tone.yellow};
    }
  `}
`;
